import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=62ade540"
import script from "./StartScreen.vue?vue&type=script&lang=ts"
export * from "./StartScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports